import React, { useState } from 'react'
import { useHistory } from 'react-router'
import { Auth } from 'aws-amplify'
import validator from 'validator'

import './RecoverPass.sass'
import { InputMask } from '@/components/InputMask/InputMask'
import { Button } from '@/components/Button/Button'
import { Link } from 'react-router-dom'
import { SimpleBanner } from '@/components/Banners/SimpleBanner'

export function RecoverPass () {
  // Send confirmation code to user's email
  const [forgotMail, setForgotMail] = useState('')
  const [isValidMail, setIsValidMail] = useState(false)
  const [invalidMailErrorMessage, setInvalidMailErrorMessage] = useState(undefined)
  const history = useHistory()

  function updateForgotMail (value) {
    setForgotMail(value)
    setIsValidMail(validator.isEmail(value))
    if (!validator.isEmail(value) && value.length > 0) {
      setInvalidMailErrorMessage('Please, set a valid email address')
    } else {
      setInvalidMailErrorMessage(undefined)
    }
  }

  function sendForgotPasswordMail () {
    Auth.forgotPassword(forgotMail)
      .then(() => history.push(`/auth/recover/set-password?mail=${forgotMail}`))
      .catch(() => history.push('/auth?code=invalid_email'))
  }

  return <div className="recover">
    <Link className='logout-link' to='/auth'>Back to login</Link>
    <div className="recover__container">
      <div className="recover__container__title">
        Recover password
      </div>
      <div className="recover__container__text-input">
        <InputMask errorMessage={invalidMailErrorMessage} label="Type the email address you used for registring into Boxes" type="text" onInput={updateForgotMail} />
      </div>
      <div className="recover__button">
        <Button content="Request recover code" size="large" disabled={!isValidMail} variant="outlined" click={sendForgotPasswordMail} />
      </div>
      <label className="recover__container__message"><SimpleBanner type='info'>After requesting the recover code, an email with such code will be sent to your backup email address.</SimpleBanner></label>
    </div>
  </div>
}
